/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import './LegalPages.css';

function TermsPage() {
    const [headerRef, isHeaderVisible] = useIntersectionObserver();

    return (
        <>
            <section ref={headerRef} className={`page-header-section section-bg-white animate-on-scroll ${isHeaderVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h1>Regulamin Świadczenia Usług</h1>
                    <p className="subtitle">Zapoznaj się z zasadami współpracy z Lingland.</p>
                </div>
            </section>

             <section className="legal-content-section section-bg-light-gray">
                 <div className="container content-narrow">
                     <div className="legal-text">

                        <h2>§1 Postanowienia Ogólne</h2>
                        <ol>
                            <li>Niniejszy Regulamin określa zasady świadczenia usług pośrednictwa w tłumaczeniach oraz usług powiązanych (dalej: "Usługi") przez Kacpra Podsiadły, działającego/ą jako freelancer (dalej: "Lingland" lub "Pośrednik") na rzecz klientów (dalej: "Klient").</li>
                            <li>Regulamin stanowi integralną część każdej umowy o świadczenie Usług zawieranej pomiędzy Lingland a Klientem.</li>
                            <li>Złożenie zamówienia na Usługę jest równoznaczne z akceptacją niniejszego Regulaminu przez Klienta.</li>
                            <li>Lingland oferuje Usługi za pośrednictwem serwisu internetowego dostępnego pod adresem www.lingland.pl (dalej: "Serwis").</li>
                        </ol>

                        <h2>§2 Zakres Usług i Rola Pośrednika</h2>
                        <ol>
                            <li>Lingland działa jako pośrednik, przyjmując od Klientów zlecenia na tłumaczenia pisemne zwykłe, specjalistyczne, lokalizację, tłumaczenia audiowizualne, korektę i edycję tekstów oraz tworzenie treści wielojęzycznych, a następnie zlecając ich wykonanie współpracującym, wykwalifikowanym tłumaczom i specjalistom (dalej: "Wykonawcy").</li>
                            <li>Lingland dba o dobór odpowiedniego Wykonawcy do danego zlecenia, koordynuje proces realizacji, przeprowadza kontrolę jakości (lub zleca jej przeprowadzenie) i pośredniczy w komunikacji między Klientem a Wykonawcą.</li>
                            <li>Lingland nie świadczy bezpośrednio usług tłumaczeń przysięgłych ani ustnych.</li>
                            <li>Lingland zobowiązuje się dołożyć należytej staranności w celu zapewnienia wysokiej jakości świadczonych Usług i terminowej realizacji zleceń.</li>
                        </ol>

                        <h2>§3 Składanie Zamówień i Wycena</h2>
                        <ol>
                             <li>Klient może złożyć zapytanie o wycenę lub zamówienie Usługi za pośrednictwem formularza w Serwisie lub drogą mailową na adres lingland.contact@gmail.com.</li>
                             <li>W zapytaniu Klient powinien określić co najmniej: parę językową, rodzaj usługi oraz załączyć pliki lub podać ich objętość.</li>
                             <li>Na podstawie zapytania Lingland przygotowuje niezobowiązującą wycenę Usługi, uwzględniającą koszty pracy Wykonawcy oraz wynagrodzenie Lingland za pośrednictwo i koordynację. Wycena przesyłana jest Klientowi drogą mailową.</li>
                             <li>Ceny orientacyjne podane w Serwisie nie stanowią oferty handlowej. Wiążąca jest cena z indywidualnej wyceny.</li>
                             <li>Podstawową jednostką rozliczeniową jest zazwyczaj 1800 znaków ze spacjami (zzs), chyba że w wycenie wskazano inaczej.</li>
                             <li>Złożenie zamówienia następuje poprzez akceptację przez Klienta warunków przedstawionych w wycenie.</li>
                        </ol>

                         <h2>§4 Realizacja Usług i Terminy</h2>
                         <ol>
                             <li>Lingland zleca wykonanie Usługi wybranemu Wykonawcy po akceptacji wyceny przez Klienta.</li>
                             <li>Termin realizacji Usługi określony jest w wycenie. Lingland nadzoruje terminowość pracy Wykonawcy. W przypadku ryzyka opóźnienia, Lingland niezwłocznie poinformuje Klienta.</li>
                             <li>Tryb ekspresowy wiąże się z wyższą ceną określoną w wycenie.</li>
                              <li>Gotowe tłumaczenie, po ewentualnej weryfikacji przez Lingland, dostarczane jest Klientowi drogą elektroniczną.</li>
                         </ol>

                         <h2>§5 Płatności</h2>
                         <ol>
                             <li>Klient zobowiązany jest do zapłaty wynagrodzenia za wykonaną Usługę zgodnie z zaakceptowaną wyceną.</li>
                             <li>Warunki płatności określane są w wycenie.</li>
                              <li>Standardowym terminem płatności jest 7 dni od daty otrzymania rachunku/faktury (jeśli wystawiasz).</li>
                              <li>Podane ceny są cenami netto lub brutto, zgodnie z informacją w wycenie.</li>
                         </ol>

                        <h2>§6 Zobowiązania Klienta</h2>
                        <ol>
                            <li>Klient zobowiązany jest do dostarczenia kompletnych i czytelnych materiałów źródłowych.</li>
                             <li>Klient oświadcza, że posiada prawa autorskie lub licencje do przekazywanych materiałów.</li>
                             <li>Klient powinien poinformować o przeznaczeniu tłumaczenia i dostarczyć materiały referencyjne, jeśli je posiada.</li>
                            <li>Klient zobowiązany jest do terminowej zapłaty wynagrodzenia.</li>
                        </ol>

                        <h2>§7 Poufność</h2>
                        <ol>
                             <li>Lingland zobowiązuje się do zachowania poufności informacji i materiałów Klienta oraz wymaga tego samego od współpracujących Wykonawców na mocy odpowiednich umów.</li>
                             <li>Na życzenie Klienta możliwe jest podpisanie umowy o zachowaniu poufności (NDA).</li>
                        </ol>

                        <h2>§8 Prawa Autorskie</h2>
                        <ol>
                            <li>Majątkowe prawa autorskie do wykonanego tłumaczenia przechodzą na Klienta z chwilą zapłaty całości wynagrodzenia, na polach eksploatacji uzgodnionych lub wynikających z celu zamówienia, chyba że umowa stanowi inaczej.</li>
                        </ol>

                        <h2>§9 Reklamacje i Odpowiedzialność</h2>
                        <ol>
                             <li>Klient ma prawo zgłosić uwagi co do jakości Usługi w terminie 7 dni od jej otrzymania.</li>
                             <li>Lingland zobowiązuje się do rozpatrzenia reklamacji i, w przypadku jej zasadności, do zapewnienia bezpłatnego usunięcia wad przez Wykonawcę lub we własnym zakresie.</li>
                             <li>Odpowiedzialność Lingland jako pośrednika jest ograniczona do należytej staranności w wyborze Wykonawcy, koordynacji zlecenia i przekazaniu tłumaczenia. Lingland nie ponosi bezpośredniej odpowiedzialności za merytoryczne błędy w tłumaczeniu wykonanym przez Wykonawcę, chyba że wynikają one z rażącego niedbalstwa Lingland w procesie kontroli lub doboru Wykonawcy. Całkowita odpowiedzialność Lingland jest ograniczona do wysokości otrzymanego wynagrodzenia za daną Usługę.</li>
                        </ol>

                        <h2>§10 Postanowienia Końcowe</h2>
                        <ol>
                             <li>W sprawach nieuregulowanych niniejszym Regulaminem mają zastosowanie przepisy prawa polskiego.</li>
                             <li>Spory będą rozstrzygane polubownie, a w razie braku porozumienia, przez sąd właściwy według przepisów kpc</li>
                             <li>Lingland zastrzega sobie prawo do zmiany Regulaminu. Zmiany wchodzą w życie z chwilą publikacji w Serwisie.</li>
                              <li>Aktualna wersja Regulaminu jest dostępna w Serwisie.</li>
                         </ol>
                     </div>
                 </div>
            </section>
        </>
    );
}

export default TermsPage;